import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Check } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import {
        AlertDialog,
        AlertDialogTrigger,
        AlertDialogContent,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogCancel,
        AlertDialogAction,
    } from '@/components/ui/alert-dialog';
    import { useI18n } from 'vue-i18n';
    import { router } from '@inertiajs/vue3';
    import { toast } from 'vue-sonner';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';
    import { computed } from 'vue';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherClosePeriod',
  setup(__props) {

    const queryClient = useQueryClient();

    const page = usePage<SharedData>();
    const companyId = computed(() => page.props.auth.user.selected_company_id);

    const { t } = useI18n();

    const closePeriod = () => {
        router.post(
            route('v2.voucher.admin.close-period'),
            { company_id: companyId.value },
            {
                onSuccess: () => {
                    toast.success(t('vouchers.close_success'));
                    queryClient.invalidateQueries({ queryKey: [QueryKey.VOUCHERS, companyId.value] });
                },
                onError: (error) => {
                    toast.error(error.error);
                },
            },
        );
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost",
            width: "narrow",
            class: "self-start",
            size: "xs"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('vouchers.close_period')) + " ", 1),
              _createVNode(_unref(Check), { class: "text-accent" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('vouchers.js.period_title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('vouchers.js.period_content')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.no')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                variant: "default",
                onClick: closePeriod
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('forms.yes')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})